import React from "react";
const Benefits: React.FC = () => {
  const benefits = [
    {
      id: "flexible-working",
      title: "Flexible Work & Work-Life Balance",
      icon: "/careers/icons/clock.svg",
    },
    {
      id: "sport-compensation",
      title: "A Diverse & Inclusive Workplace",
      icon: "/careers/icons/diverse-workplace.svg",
    },
    {
      id: "health-care",
      title: "An Innovative & Collaborative Work Culture",
      icon: "/careers/icons/innovative.svg",
    },
    {
      id: "marriage-bonus",
      title: "Recognition & Rewards for Excellence",
      icon: "/careers/icons/handclap.svg",
    },
    {
      id: "team-events",
      title: "A Fun & Engaging Workplace",
      icon: "/careers/icons/confetti.svg",
    },
    {
      id: "professional-budget",
      title: "Acccess to Cutting-Edge Technology & Tools",
      icon: "/careers/icons/rocket-launch.svg",
    },
    {
      id: "vacation",
      title: "Exciting Career Advancement Opportunities",
      icon: "/careers/icons/graph-up.svg",
    },
    {
      id: "salary",
      title: "Competitive Compensation & Comprehensive  Benefits",
      icon: "/careers/icons/money-bag.svg",
    },
    {
      id: "eyeglasses",
      title: "Meaningful Work the Lasting Impact",
      icon: "/careers/icons/love.svg",
    },
    {
      id: "first-graders",
      title: "Strong Leadership with a Clear Vision",
      icon: "/careers/icons/target.svg",
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center w-full">
      <div className="flex flex-col w-full max-w-5xl text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[3rem]">
        <h3>What benefits are waiting for you?</h3>
        <div className="w-full flex justify-center items-center">
          <div className="text-xs max-w-[18rem] sm:max-w-[22rem] lg:max-w-[40rem] xl:max-w-[43rem] lg:pb-3 text-center sm:text-sm lg:text-base xl:text-2xl pt-4">
            <h5 className="text-center">
              Dream Weavers offers a variety of hand-picked benefits that you
              can take advantage of!
            </h5>
          </div>
        </div>
      </div>
      <div className="grid justify-center lg:pt-4 xl:pt-14 items-center grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5 w-full max-w-5xl lg:max-w-full lg:px-10 py-5">
        {benefits.map((benefit) => {
          return (
            <div
              key={benefit.id}
              className="bg-gradient-to-b from-[#DEFFFA] to-[#F0F9FF] h-full lg:text-base xl:text-xl text-xs p-3 py-5 flex items-center gap-2 lg:gap-3"
            >
              <img src={benefit.icon} alt="" className="w-7 lg:w-9" />
              <p>{benefit.title}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Benefits;
